import Dialog from '@mui/material/Dialog';
import { DialogTitle, DialogActions, TextField, Box, Button, Grid, DialogContent } from '@mui/material';
import { WebUserModel } from 'src/types/WebUserModel';
import * as Yup from 'yup';
import { Field, Formik } from 'formik';
import api from '../../api/Api';
import { Logger } from 'src/utils/logger';

interface UserEditFormProps {
  onCancel: () => void;
  onLoadUsers: () => void;
  isOpen: boolean;
  user: WebUserModel;
  title: string;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const UserEditForm = (props: UserEditFormProps) => {
  return (
    <Dialog maxWidth={props.maxWidth || 'xs'} fullWidth open={props.isOpen} onClose={props.onCancel}>
      <DialogTitle id="confirmation-dialog-title">{props.title} </DialogTitle>

      <DialogContent>
        <Formik
          initialValues={props.user}
          validationSchema={Yup.object().shape({
            userName: Yup.string().required('Username is required'),
            email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
            firstName: Yup.string().required('First name is required'),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }): Promise<void> => {
            delete values.submit;

            console.log('obj to submit - ', {
              ...props.user,
              ...values,
            });

            try {
              let success = await api.post<WebUserModel>('/user/updatewebuser', {
                ...props.user,
                ...values,
              });
              if (success) {
                setStatus({ success: true });
                setSubmitting(false);
                props.onLoadUsers();
                props.onCancel();
                console.log(success, 'loading contacts');
              } else {
                Logger.error('Could not update user, check server log');
              }
            } catch (err) {
              console.log(err);
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid size={{ xs: 6 }}>
                  <TextField
                    label="Username"
                    type="text"
                    name="userName"
                    error={Boolean(touched.userName && errors.userName)}
                    helperText={touched.userName && errors.userName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.userName}
                    variant="outlined"
                  />
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <TextField
                    label="Email"
                    type="text"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    variant="outlined"
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <TextField
                    label="First Name"
                    type="text"
                    name="firstName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    variant="outlined"
                    error={Boolean(touched.firstName && errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                  />
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <TextField label="Last Name" type="text" name="lastName" onBlur={handleBlur} onChange={handleChange} value={values.lastName} variant="outlined" />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextField fullWidth label="Job Title" type="text" name="title" onBlur={handleBlur} onChange={handleChange} value={values.title} variant="outlined" />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    fullWidth
                    label="New Password"
                    type="text"
                    name="newPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.newPassword}
                    variant="outlined"
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  {/* <FormControlLabel
                    sx={{ ml: { xs: 1, md: 0 }, py: { xs: 1, md: 0 } }}
                    control={<Checkbox size="small" checked={values.active} />}
                    label="Active"
                  /> */}
                  <label>
                    <Field type="checkbox" name="active" />
                    Active
                  </label>
                </Grid>
              </Grid>

              <DialogActions>
                <Box sx={{ mt: 2 }}>
                  <Button color="primary" disabled={isSubmitting} type="submit" variant="contained" sx={{ m: 2 }}>
                    Submit
                  </Button>
                  <Button type={'submit'} variant="outlined" onClick={props.onCancel}>
                    Cancel
                  </Button>
                </Box>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};
export default UserEditForm;
